import { Component } from '@angular/core';
import { DialogBasedSelector } from '@lx/quote-tool/lite/shared/ui/directives';
import { CourseDetails } from '@lx/quote-tool/lite/shared/types';
import { SidePanelComponent } from '@lx/quote-tool/lite/shared/ui/components';
import { AyaCourseSelectorComponent } from '../aya-course-selector/aya-course-selector.component';
import { SelectorFieldContainerComponent } from '@lx/quote-tool/lite/shared/ui/components';

@Component({
  standalone: true,
  selector: 'lx-aya-course-selector-field',
  imports: [SelectorFieldContainerComponent, SidePanelComponent, AyaCourseSelectorComponent, SelectorFieldContainerComponent],
  templateUrl: './aya-course-selector-field.component.html',
  styleUrls: ['./aya-course-selector-field.component.scss'],
})
export class AyaCourseSelectorFieldComponent extends DialogBasedSelector<CourseDetails> {}
